<template>

    <div v-for="(item, index) in LPPartner" :key="index" class="mt-3">

        <div class="row">
            <div class="col-md-8 col-lg-6">
                <!-- 
                <ui-input-box-floating class="mb-3" :error="getError(index, 'LPPartnerName')">
                    <ui-input v-model="item.LPPartnerName" type="text" placeholder="Название или ИНН"
                        :disabled="disabled" />
                    <ui-input-label>Название или ИНН</ui-input-label>
                </ui-input-box-floating> -->

                <Autocomplete class="mb-3" v-model="item.LPPartnerName" type="party" label="Название или ИНН"
                    placeholder="Название или ИНН" :error="getError(index, 'LPPartnerName')" :disabled="disabled" @select="(d) => {
                        item.LPPartnerName = d.value || ''
                    }" />


            </div>
        </div>

        <button @click="() => del(index)" class="btn btn-ghost btn-small mb-2"
            :disabled="LPPartner.length == 1 || disabled">Удалить контрагента</button>
    </div>

    <button @click="add" class="btn btn-base btn-small" :disabled="disabled">Добавить контрагента</button>
</template>

<script setup>

import { ref, onMounted, watch } from 'vue'

import Autocomplete from "../../../component/Autocomplete/index.vue";

const props = defineProps({
    data: {
        type: Object,
        default: {}
    },
    errors: {
        type: Object,
        default: {}
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const LPPartner = ref([])

const add = () => {
    LPPartner.value = [...LPPartner.value, {}]
}

const del = (index) => {
    LPPartner.value = LPPartner.value.filter((item, itemIndex) => itemIndex !== index)
}

const getError = (index, field) =>
    props.errors?.LPPartner?.[index]?.[field] || false

onMounted(async () => {

    const isValidObjectArray = Array.isArray(props.data?.LPPartner) && props.data.LPPartner.every(item => typeof item === 'object' && !Array.isArray(item))

    LPPartner.value = isValidObjectArray ? props.data.LPPartner : [{}]

})

watch(LPPartner, (newValue) => {

    props.data.LPPartner = newValue

}, { deep: true })


</script>